import Vue from "vue";
import Vuetify, {
  VTextField,
  VTextarea,
  VCombobox,
  VAutocomplete,
  VDatePicker,
  VSelect,
  VRadio,
  VCheckbox,
} from "vuetify/lib";
import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify, {
  components: {
    VTextField,
    VTextarea,
    VCombobox,
    VAutocomplete,
    VDatePicker,
    VSelect,
    VRadio,
    VCheckbox,
  },
});

export default new Vuetify({
  icons: {
    iconfont: "fa",
  },
  theme: {
    themes: {
      // dark: {
      //   primary: colors.purple as any
      // },
      light: {
        primary: colors.purple as any,
      },
    },
  },
});
